import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "container app-type"
};
const _hoisted_2 = {
  class: "handle-box"
};
const _hoisted_3 = ["data-id"];
const _hoisted_4 = {
  class: "dialog-footer"
};
import { onMounted, onUnmounted, reactive, ref } from "vue";
import { httpGet, httpPost } from "@/utils/http";
import { ElMessage } from "element-plus";
import { removeArrayItem } from "@/utils/libs";
import { Sortable } from "sortablejs";
import Compressor from "compressorjs";

// 变量定义

export default {
  __name: 'AppType',
  setup(__props) {
    const items = ref([]);
    const item = ref({});
    const showDialog = ref(false);
    const title = ref("");
    const rules = reactive({
      name: [{
        required: true,
        message: '请输入分类名称',
        trigger: 'change'
      }]
    });
    const loading = ref(true);
    const formRef = ref(null);

    // 获取数据
    const fetchData = () => {
      httpGet('/api/admin/app/type/list').then(res => {
        if (res.data) {
          items.value = res.data;
        }
        loading.value = false;
      }).catch(() => {
        ElMessage.error("获取数据失败");
      });
    };
    onMounted(() => {
      fetchData();
      const drawBodyWrapper = document.querySelector('.el-table__body tbody');

      // 初始化拖动排序插件
      Sortable.create(drawBodyWrapper, {
        sort: true,
        animation: 500,
        onEnd({
          newIndex,
          oldIndex,
          from
        }) {
          if (oldIndex === newIndex) {
            return;
          }
          const sortedData = Array.from(from.children).map(row => row.querySelector('.sort').getAttribute('data-id'));
          const ids = [];
          const sorts = [];
          sortedData.forEach((id, index) => {
            ids.push(parseInt(id));
            sorts.push(index + 1);
            items.value[index].sort_num = index + 1;
          });
          httpPost("/admin/app/type/sort", {
            ids: ids,
            sorts: sorts
          }).then(() => {}).catch(e => {
            ElMessage.error("排序失败：" + e.message);
          });
        }
      });
    });
    const add = function () {
      title.value = "新增分类";
      showDialog.value = true;
      item.value = {
        enabled: true
      };
    };
    const edit = function (row) {
      title.value = "修改分类";
      showDialog.value = true;
      item.value = row;
    };
    const save = function () {
      formRef.value.validate(valid => {
        if (!item.value.sort_num) {
          item.value.sort_num = items.value.length;
        }
        if (valid) {
          showDialog.value = false;
          httpPost('/api/admin/app/type/save', item.value).then(() => {
            ElMessage.success('操作成功！');
            fetchData();
          }).catch(e => {
            ElMessage.error('操作失败，' + e.message);
          });
        } else {
          return false;
        }
      });
    };

    // 设置启用状态
    const enableSet = row => {
      httpPost('/api/admin/app/type/enable', {
        id: row.id,
        enabled: row.enabled
      }).then(() => {
        ElMessage.success("操作成功！");
      }).catch(e => {
        ElMessage.error("操作失败：" + e.message);
      });
    };

    // 删除数据
    const remove = function (row) {
      httpGet('/api/admin/app/type/remove?id=' + row.id).then(() => {
        ElMessage.success("删除成功！");
        items.value = removeArrayItem(items.value, row, (v1, v2) => {
          return v1.id === v2.id;
        });
      }).catch(e => {
        ElMessage.error("删除失败：" + e.message);
      });
    };

    // 图片上传
    const uploadImg = file => {
      // 压缩图片并上传
      new Compressor(file.file, {
        quality: 0.6,
        success(result) {
          const formData = new FormData();
          formData.append('file', result, result.name);
          // 执行上传操作
          httpPost('/api/admin/upload', formData).then(res => {
            item.value.icon = res.data.url;
            ElMessage.success('上传成功');
          }).catch(e => {
            ElMessage.error('上传失败:' + e.message);
          });
        },
        error(e) {
          ElMessage.error('上传失败:' + e.message);
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_popconfirm = _resolveComponent("el-popconfirm");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
        type: "primary",
        icon: _ctx.Plus,
        onClick: add
      }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("新增")])),
        _: 1
      }, 8, ["icon"])]), _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_table, {
          data: items.value,
          "row-key": row => row.id,
          "table-layout": "auto"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            type: "selection",
            width: "38"
          }), _createVNode(_component_el_table_column, {
            prop: "name",
            label: "分类名称"
          }, {
            default: _withCtx(scope => [_createElementVNode("span", {
              class: "sort",
              "data-id": scope.row.id
            }, [_cache[6] || (_cache[6] = _createElementVNode("i", {
              class: "iconfont icon-drag"
            }, null, -1)), _createTextVNode(" " + _toDisplayString(scope.row.name), 1)], 8, _hoisted_3)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "图标",
            prop: "icon"
          }, {
            default: _withCtx(scope => [scope.row.icon ? (_openBlock(), _createBlock(_component_el_image, {
              key: 0,
              src: scope.row.icon,
              style: {
                "width": "45px",
                "height": "45px",
                "border-radius": "50%"
              }
            }, null, 8, ["src"])) : (_openBlock(), _createBlock(_component_el_tag, {
              key: 1,
              type: "info"
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("无图标")])),
              _: 1
            }))]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "enabled",
            label: "启用状态"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_switch, {
              modelValue: scope.row['enabled'],
              "onUpdate:modelValue": $event => scope.row['enabled'] = $event,
              onChange: $event => enableSet(scope.row)
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "操作",
            width: "180"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_button, {
              size: "small",
              type: "primary",
              onClick: $event => edit(scope.row)
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("编辑")])),
              _: 2
            }, 1032, ["onClick"]), _createVNode(_component_el_popconfirm, {
              title: "确定要删除当前记录吗?",
              onConfirm: $event => remove(scope.row),
              width: 200
            }, {
              reference: _withCtx(() => [_createVNode(_component_el_button, {
                size: "small",
                type: "danger"
              }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode("删除")])),
                _: 1
              })]),
              _: 2
            }, 1032, ["onConfirm"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data", "row-key"])]),
        _: 1
      }), _createVNode(_component_el_dialog, {
        modelValue: showDialog.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => showDialog.value = $event),
        title: title.value,
        "close-on-click-modal": false,
        style: {
          "width": "90%",
          "max-width": "600px"
        }
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_4, [_createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = $event => showDialog.value = false)
        }, {
          default: _withCtx(() => _cache[11] || (_cache[11] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: save
        }, {
          default: _withCtx(() => _cache[12] || (_cache[12] = [_createTextVNode("提交")])),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: item.value,
          "label-width": "120px",
          ref_key: "formRef",
          ref: formRef,
          rules: rules
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "分类名称：",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: item.value.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => item.value.name = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "应用图标：",
            prop: "icon"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: item.value.icon,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => item.value.icon = $event)
            }, {
              append: _withCtx(() => [_createVNode(_component_el_upload, {
                "auto-upload": true,
                "show-file-list": false,
                "http-request": uploadImg
              }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode(" 上传 ")])),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "启用状态：",
            prop: "enable"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_switch, {
              modelValue: item.value.enabled,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => item.value.enabled = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue", "title"])])), [[_directive_loading, loading.value]]);
    };
  }
};